import React, { useEffect } from 'react';
import Highcharts from 'highcharts';
import { text } from 'stream/consumers';

interface MyChartProps {
  chartId: string;  // Nuevo prop para identificar cada instancia del gráfico
  plot: any,
  data: any
}


const MyChartPing: React.FC<MyChartProps> = ({ chartId, plot, data }) => {

  useEffect(() => {
    const options: Highcharts.Options = {
      title: {
        text: 'Latency',
        align: 'left',
      },
      subtitle: {
        text: 'This is the latency history.',
        align: 'left'
      },
      yAxis: {
        title: {
          text: 'Avg (ms)'
        }
      },
      xAxis: {
        type: 'datetime',
        categories: plot,
        labels: {
          overflow: 'justify'
        }
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle'
      },
      plotOptions: {
        series: {
          label: {
            connectorAllowed: false
          },
        }
      },
      series: [{
        type: 'line',
        name: 'Avg',
        data: data
      }],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      },
      credits: {
        enabled: false
      }
    };

    Highcharts.chart(`container-${chartId}`, options);
  }, [chartId, plot, data]);

  return (
    <div id={`container-${chartId}`}>
      {/* El contenedor div donde se renderizará el gráfico */}
    </div>
  );
};

export default MyChartPing;